import { render, staticRenderFns } from "./add.vue?vue&type=template&id=6035ee4c&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035ee4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6035ee4c')) {
      api.createRecord('6035ee4c', component.options)
    } else {
      api.reload('6035ee4c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=6035ee4c&scoped=true&", function () {
      api.rerender('6035ee4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMember/account/add.vue"
export default component.exports